// i18n keys of the work package "apppack" — Compile & email application documents on a job (report 54fd6fc9;
// src/components/Jobs/AppPackDialog.tsx). en / zh / th. ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  apk_button: 'Compile Application Documents',
  apk_title: 'Compile Application Documents',
  apk_intro: 'Each application document this job type lists (Admin → Jobs → Required documents) is looked up in Our Documents for this client: the newest file of that type, dated no earlier than six months before the visa expiry, or, for a yearly document, from the year before. Everything found goes into one PDF in checklist order, behind a cover page listing what is included and what is missing.',
  apk_job: 'Job #{{no}}',
  apk_expiry: 'Visa expiry',
  apk_expiry_filed: 'From the stamp on file: {{name}}',
  apk_expiry_typed: 'Typed here. The stamp on file says {{date}}.',
  apk_expiry_typed_nofile: 'Typed here. No visa or extension stamp for this person was found on file.',
  apk_expiry_none: 'No visa or extension stamp for this person was found in Our Documents. Type the expiry; until then the six months are counted back from today.',
  apk_window: 'Files dated from {{date}} on are used.',
  apk_window_yearly: 'Yearly documents, from {{date}} on: {{names}}.',
  apk_window_any: 'Any date: {{names}}.',
  apk_checklist: 'Checklist',
  apk_summary: '{{found}} of {{wanted}} found',
  apk_loading: 'Searching Our Documents…',
  apk_none_listed: 'This job type lists no application documents yet. Add them in Admin → Jobs → Required documents.',
  apk_not_found: 'Not found on file',
  apk_short: '{{n}} not found on file',
  apk_copies: '{{n}} copies in the PDF',
  apk_older: 'The newest on file, {{name}}, is dated {{date}}, which is before {{from}}.',
  apk_in_folder: 'in {{path}}',
  apk_no_email: 'Do not email: listed on the cover page, never attached',
  apk_to: 'To',
  apk_cc: 'Cc',
  apk_addr_hint: 'Any address. Separate several with commas.',
  apk_from: 'Sent from {{from}} as one PDF attachment.',
  apk_nothing: 'None of these documents was found on file, so there is nothing to send.',
  apk_bad_to: 'Type at least one email address in To.',
  apk_bad_addr: '"{{addr}}" is not an email address.',
  apk_send: 'Send',
  apk_sending: 'Compiling and sending…',
  apk_close: 'Close',
  apk_sent: 'Sent {{when}} to {{to}}: {{file}} ({{size}}), {{included}} of {{wanted}} documents.',
  apk_sent_cc: 'Cc: {{cc}}',
  apk_sent_unmerged: 'could not be merged (encrypted or unreadable), so it is not in the PDF',
  apk_last: 'Last sent {{when}} by {{who}}: {{what}}',
  apk_tm7_pdf: 'Filled-in TM.7 (PDF)',
  apk_tm7_busy: 'Reading the passport and filling in the TM.7…',
  apk_tm7_passport: 'Filled in from the passport',
  apk_tm7_record: 'Filled in from the client record (no passport on file)',
  apk_tm7_unread: 'Filled in from the client record: could not read the passport',
  apk_tm7_filled: 'Not on file, so a TM.7 filled in from the passport and the client record goes into the PDF instead.',
  apk_last_page: 'Last page of {{name}}',
};
export const zh: Record<string, string> = {
  apk_button: '汇编申请文件',
  apk_title: '汇编申请文件',
  apk_intro: '本 Job 类型列出的每份申请文件(Admin → Jobs → Required documents)都会在 Our Documents 中按该客户查找:取该类型最新的文件,且日期不早于签证到期日前六个月;每年一份的文件则从前一年起算。找到的文件按清单顺序合并成一个 PDF,首页为封面,列明已包含和缺少的文件。',
  apk_job: 'Job #{{no}}',
  apk_expiry: '签证到期日',
  apk_expiry_filed: '取自已归档的签证章:{{name}}',
  apk_expiry_typed: '在此手动填写。已归档的签证章日期为 {{date}}。',
  apk_expiry_typed_nofile: '在此手动填写。档案中没有找到此人的签证或延期章。',
  apk_expiry_none: '在 Our Documents 中没有找到此人的签证或延期章。请填写到期日;填写前,六个月从今天往前计算。',
  apk_window: '使用日期在 {{date}} 及之后的文件。',
  apk_window_yearly: '每年一份的文件使用 {{date}} 及之后的:{{names}}。',
  apk_window_any: '不限日期:{{names}}。',
  apk_checklist: '清单',
  apk_summary: '已找到 {{found}} / {{wanted}}',
  apk_loading: '正在搜索 Our Documents…',
  apk_none_listed: '本 Job 类型尚未列出申请文件。请在 Admin → Jobs → Required documents 中添加。',
  apk_not_found: '档案中未找到',
  apk_short: '{{n}} 份档案中未找到',
  apk_copies: '在 PDF 中放入 {{n}} 份',
  apk_older: '档案中最新的一份 {{name}} 日期为 {{date}},早于 {{from}}。',
  apk_in_folder: '位于 {{path}}',
  apk_no_email: '不可外发:只在封面列出,不会附上',
  apk_to: '收件人',
  apk_cc: '抄送',
  apk_addr_hint: '可填写任何地址,多个地址用逗号分隔。',
  apk_from: '从 {{from}} 发出,附一个 PDF。',
  apk_nothing: '这些文件在档案中都没有找到,没有可发送的内容。',
  apk_bad_to: '请在收件人中至少填写一个邮箱地址。',
  apk_bad_addr: '"{{addr}}" 不是邮箱地址。',
  apk_send: '发送',
  apk_sending: '正在汇编并发送…',
  apk_close: '关闭',
  apk_sent: '已于 {{when}} 发送给 {{to}}:{{file}}({{size}}),共 {{included}} / {{wanted}} 份文件。',
  apk_sent_cc: '抄送:{{cc}}',
  apk_sent_unmerged: '无法合并(已加密或无法读取),未放入 PDF',
  apk_last: '上次发送 {{when}},操作人 {{who}}:{{what}}',
  apk_tm7_pdf: '已填写的 TM.7(PDF)',
  apk_tm7_busy: '正在读取护照并填写 TM.7…',
  apk_tm7_passport: '根据护照填写',
  apk_tm7_record: '根据客户资料填写(档案中没有护照)',
  apk_tm7_unread: '根据客户资料填写:无法读取护照',
  apk_tm7_filled: '档案中没有,因此会根据护照和客户资料填写一份 TM.7 放入 PDF。',
  apk_last_page: '{{name}} 的最后一页',
};
export const th: Record<string, string> = {
  apk_button: 'รวบรวมเอกสารประกอบคำขอ',
  apk_title: 'รวบรวมเอกสารประกอบคำขอ',
  apk_intro: 'เอกสารประกอบคำขอแต่ละรายการที่งานประเภทนี้กำหนดไว้ (Admin → Jobs → Required documents) จะถูกค้นหาใน Our Documents ของลูกค้ารายนี้ โดยใช้ไฟล์ล่าสุดของประเภทนั้นที่ลงวันที่ไม่ก่อนหกเดือนก่อนวันหมดอายุวีซ่า ส่วนเอกสารรายปีใช้ตั้งแต่ปีก่อนหน้า ไฟล์ที่พบจะรวมเป็น PDF ไฟล์เดียวตามลำดับรายการ โดยมีหน้าปกแสดงว่ามีเอกสารใดบ้างและขาดเอกสารใด',
  apk_job: 'งาน #{{no}}',
  apk_expiry: 'วันหมดอายุวีซ่า',
  apk_expiry_filed: 'จากตราประทับที่จัดเก็บไว้: {{name}}',
  apk_expiry_typed: 'กรอกเองที่นี่ ตราประทับที่จัดเก็บไว้ระบุวันที่ {{date}}',
  apk_expiry_typed_nofile: 'กรอกเองที่นี่ ไม่พบตราประทับวีซ่าหรือการต่ออายุของบุคคลนี้ในแฟ้ม',
  apk_expiry_none: 'ไม่พบตราประทับวีซ่าหรือการต่ออายุของบุคคลนี้ใน Our Documents กรุณากรอกวันหมดอายุ ระหว่างนี้ระบบจะนับหกเดือนย้อนหลังจากวันนี้',
  apk_window: 'ใช้ไฟล์ที่ลงวันที่ตั้งแต่ {{date}} เป็นต้นไป',
  apk_window_yearly: 'เอกสารรายปีใช้ไฟล์ที่ลงวันที่ตั้งแต่ {{date}} เป็นต้นไป: {{names}}',
  apk_window_any: 'ไม่จำกัดวันที่: {{names}}',
  apk_checklist: 'รายการเอกสาร',
  apk_summary: 'พบ {{found}} จาก {{wanted}}',
  apk_loading: 'กำลังค้นหาใน Our Documents…',
  apk_none_listed: 'งานประเภทนี้ยังไม่มีรายการเอกสารประกอบคำขอ เพิ่มได้ที่ Admin → Jobs → Required documents',
  apk_not_found: 'ไม่พบในแฟ้ม',
  apk_short: 'ไม่พบในแฟ้ม {{n}} ฉบับ',
  apk_copies: 'ใส่ใน PDF {{n}} ชุด',
  apk_older: 'ฉบับล่าสุดในแฟ้มคือ {{name}} ลงวันที่ {{date}} ซึ่งก่อน {{from}}',
  apk_in_folder: 'ใน {{path}}',
  apk_no_email: 'ห้ามส่งอีเมล: แสดงในหน้าปกเท่านั้น ไม่แนบไปด้วย',
  apk_to: 'ถึง',
  apk_cc: 'สำเนาถึง',
  apk_addr_hint: 'ใส่ที่อยู่ใดก็ได้ หากมีหลายที่อยู่ให้คั่นด้วยเครื่องหมายจุลภาค',
  apk_from: 'ส่งจาก {{from}} เป็นไฟล์แนบ PDF ไฟล์เดียว',
  apk_nothing: 'ไม่พบเอกสารเหล่านี้ในแฟ้มเลย จึงไม่มีอะไรให้ส่ง',
  apk_bad_to: 'กรุณากรอกที่อยู่อีเมลอย่างน้อยหนึ่งรายการในช่องถึง',
  apk_bad_addr: '"{{addr}}" ไม่ใช่ที่อยู่อีเมล',
  apk_send: 'ส่ง',
  apk_sending: 'กำลังรวบรวมและส่ง…',
  apk_close: 'ปิด',
  apk_sent: 'ส่งเมื่อ {{when}} ถึง {{to}}: {{file}} ({{size}}) เอกสาร {{included}} จาก {{wanted}} รายการ',
  apk_sent_cc: 'สำเนาถึง: {{cc}}',
  apk_sent_unmerged: 'รวมไม่ได้ (ถูกเข้ารหัสหรืออ่านไม่ได้) จึงไม่อยู่ใน PDF',
  apk_last: 'ส่งครั้งล่าสุด {{when}} โดย {{who}}: {{what}}',
  apk_tm7_pdf: 'TM.7 ที่กรอกแล้ว (PDF)',
  apk_tm7_busy: 'กำลังอ่านหนังสือเดินทางและกรอก TM.7…',
  apk_tm7_passport: 'กรอกจากหนังสือเดินทาง',
  apk_tm7_record: 'กรอกจากข้อมูลลูกค้า (ไม่มีหนังสือเดินทางในแฟ้ม)',
  apk_tm7_unread: 'กรอกจากข้อมูลลูกค้า: อ่านหนังสือเดินทางไม่ได้',
  apk_tm7_filled: 'ไม่มีในแฟ้ม จึงใช้ TM.7 ที่กรอกจากหนังสือเดินทางและข้อมูลลูกค้าใส่ใน PDF แทน',
  apk_last_page: 'หน้าสุดท้ายของ {{name}}',
};
